import { EmailServiceService } from "./../../../services/email-service.service";
import { Component, OnInit, OnDestroy, AfterViewInit } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { ProductsService } from "./../../../services/products.service";
import { LoaderService } from "./../../../services/loader.service";
import { AppSetting } from "./../../../global/appsetting";
import { Location } from "@angular/common";
import {
  GaAnalyticsService,
  EVENT_TYPES,
} from "src/app/services/ga-analytics.service";
import {
  AvailableFileFormat,
  DaysPrice,
  ExistFileFormat,
  FixesPrices,
  OptionView,
  Product,
  ProductOption,
  ProductView,
} from "src/app/models/products/products";
import { ClientTransaction } from "src/app/models/products/transactions";
import { TransactionsService } from "src/app/services/transactions.service";
import { ProductDetailsUiStateService } from "./product-details-ui-state.service";
import {
  ClientTransactionForm,
  ClientTransactionViewForm,
} from "src/app/models/forms/transactions-form";
import { AbstractControl, FormArray, FormGroup } from "@angular/forms";
import { takeWhile } from "rxjs";

@Component({
  selector: "app-online-product-details",
  templateUrl: "./online-product-details.component.html",
  styleUrls: ["./online-product-details.component.scss"],
})
export class OnlineProductDetailsComponent
  implements OnInit, OnDestroy, AfterViewInit
{
  get clientTransactionForm(): AbstractControl<ClientTransactionForm> {
    return this.pUiService.clientTransactionForm;
  }

  get apartmentSize(): AbstractControl<number> {
    return this.pUiService.apartmentSize;
  }

  get timeToGetProgramInDays(): AbstractControl<number> {
    return this.pUiService.timeToGetProgramInDays;
  }

  get existFileFormat(): AbstractControl<string> {
    return this.pUiService.existFileFormat;
  }

  get wantedFileFormat(): AbstractControl<string> {
    return this.pUiService.wantedFileFormat;
  }

  get fixesTimes(): AbstractControl<number> {
    return this.pUiService.fixesTimes;
  }

  get dynamicOptionResponses(): 
    FormArray
  {
    return this.pUiService.dynamicOptionResponses;
  }

  get isForOperate(): AbstractControl {
    return this.pUiService.isForOperate;
  }

  clientTransactionViewForm: FormGroup<ClientTransactionViewForm>;
  numberOfFixesArr: Array<number> = [];
  apartmentSizesArray: Array<number> = [];
  disableRemoveFileFireFox = false;
  ccno = "";
  selectedCardCode = 1;
  selectedYear = 2017;
  selectedMonth = 1;
  cardsTypes = [
    { code: 1, name: "ישראכרט" },
    { code: 2, name: "ויזה כ.א.ל" },
    { code: 3, name: "דיינרס" },
    { code: 4, name: "אמריקן אקספרס" },
    { code: 5, name: "JCB" },
    { code: 6, name: "לאומי קארד" },
  ];
  months = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];
  years = [];

  picPaths = [];

  thisOrderProductDetailComponent: OnlineProductDetailsComponent;


  private _componentActive = true;

  constructor(
    public route: ActivatedRoute,
    public productsService: ProductsService,
    public loaderService: LoaderService,
    public emailService: EmailServiceService,
    public appSetting: AppSetting,
    private location: Location,
    private gaAnalyticsService: GaAnalyticsService,
    private _transactionsService: TransactionsService,
    public pUiService: ProductDetailsUiStateService,
    private _route: ActivatedRoute
  ) {}

  ngOnInit(): void {
    if (
      document.querySelector(".body-online") &&
      document.querySelector(".body-online").classList
    ) {
      document.querySelector(".body-online").classList.add("details-page");
    }

    

    this.route.url
      .pipe(takeWhile(() => this._componentActive))
      .subscribe((url) => {
        this.pUiService.resetData();
        this.pUiService.createForm();
        this.clientTransactionViewForm =
          this.pUiService.clientTransactionViewForm;
        this.setStartUpData();
        this.updateProductData();
      });
    this.location.subscribe((x) => {
      (document.querySelector(".stage") as HTMLDivElement).click();
    });
     
  }

  updateProductData(): void {
    this.loaderService.displayLoader(false);
    this.pUiService.productId = parseInt(this.route.snapshot.params.id, 10);
    this.productsService
      .GetProductViewByProdId(this.pUiService.productId)
      .pipe(takeWhile(() => this._componentActive))
      .subscribe(
        {
          next: (res: ProductView) => {
            this.loaderService.hideLoader();
            this.pUiService.productView = res;
            if (this.pUiService.productView.ProductItem != null) {
              const trnsIndex = this.route.snapshot.params.i;
              if (trnsIndex) {
                const optionId =
                  this._transactionsService.clientTransactionsView$.getValue()[
                    trnsIndex
                  ].ClientTransaction.ProductOptionId;
                this.pUiService.currentOptionIndex =
                  this.pUiService.productView.ProductOptionItems.findIndex(
                    (x) => x.ProductOptionItem.Id === optionId
                  );
                this.pUiService.chosenOption =
                  this.pUiService.productView.ProductOptionItems[
                    this.pUiService.currentOptionIndex
                  ];
                  setTimeout(() => {
                    this.pUiService.setExistDynamicOptions(trnsIndex);
                  });
                  this.pUiService.setExistDynamicOptions(trnsIndex);
                this.updateExistTrns(trnsIndex);
                this.pUiService.files =
                  this._transactionsService.fileList.data.items[trnsIndex];
              } else {
                this.pUiService.chosenOption = this.GetDefaultChosenOption();
                this.apartmentSize.setValue(
                  this.pUiService.chosenOption.ProductOptionItem.ApartmentSize
                );
  
                this.pUiService.updateFields();
                
              }
            }
          },
          error: (error) => {
            this._handleGetProductError(error);
          }
        }
      );
    this.generateYears();
    this.pUiService.currentUrl = window.location.href;
    document.getElementsByTagName("html")[0].scrollTop = 0;
  }

  

  ngAfterViewInit(): void {
    (function (d, s, id) {
      let js;
      const fjs = d.getElementsByTagName(s)[0];
      js = d.createElement(s);
      js.id = id;
      js.src = "//connect.facebook.net/he_IL/sdk.js#xfbml=1&version=v2.4";

      if (d.getElementById(id)) {
        delete (<any>window).FB;
        fjs.parentNode.replaceChild(js, fjs);
      } else {
        fjs.parentNode.insertBefore(js, fjs);
      }
    })(document, "script", "facebook-jssdk");
  }

  generateYears(): void {
    const date = new Date();
    for (let i = 0; i < 10; i++) {
      this.years.push(date.getFullYear() + i);
    }
    this.selectedYear = this.years[0];
    this.selectedMonth = date.getMonth();
  }

  changeCardType(event: Event): void {
    const value = (event.target as HTMLInputElement).value;
    for (const item of this.cardsTypes) {
      if (item.code === parseInt(value)) {
        this.selectedCardCode = item.code;
      }
    }
  }

  ChangeMonth(event): void {
    const value = event.target.value;
    for (const item of this.months) {
      if (item === value) {
        this.selectedMonth = item;
      }
    }
  }

  changeYear(event: Event): void {
    const value = (event.target as HTMLInputElement).value;
    for (const item of this.years) {
      if (item === value) {
        this.selectedYear = item;
      }
    }
  }

  continueOrder(step: number): void {
    this.pUiService.continueOrder(step, this._route.snapshot.params.i);
  }

  updateExistTrns(i: number): void {
    const clientTrns: ClientTransaction =
      this._transactionsService.clientTransactionsView$.getValue()[i]
        .ClientTransaction;
    this.pUiService.finalPrice.setValue(clientTrns.FinalPrice);
    this.isForOperate.setValue(clientTrns.IsForOperate);
    this.existFileFormat.setValue(
      this.pUiService.chosenOption.ExistFileFormatItems.find(
        (x) => x.FormatName.indexOf(clientTrns.ExistFileFormat) > -1
      )?.FormatName
    );
    this.wantedFileFormat.setValue(
      this.pUiService.chosenOption.AvailableFileFormatItems.find(
        (x) => x.FormatName.indexOf(clientTrns.WantedFileFormat) > -1
      )?.FormatName
    );
    this.pUiService.OriginalPrice.setValue(clientTrns.OriginalPrice);
    this.timeToGetProgramInDays.setValue(
      this.pUiService.chosenOption.DayAndPricesItems.find(
        (x) => x.Days === parseInt(clientTrns.TimeToGetProgramInDays.toString())
      )?.Days
    );
    this.fixesTimes.setValue(
      this.pUiService.chosenOption.FixesPricesItems.find(
        (x) => x.NumberOfFixes === parseInt(clientTrns.FixesTimes.toString())
      )?.NumberOfFixes
    );
    this.apartmentSize.setValue(parseInt(clientTrns.ApartmentSize.toString()), {emitEvent: false});
    this.pUiService.addToFinalPrice();
  }

  

  setStartUpData(): void {
    this.pUiService.productView = new ProductView();
    this.pUiService.productView = this.pUiService.productView;
    this.pUiService.productView.ProductItem = new Product();
    this.pUiService.productView.ProductOptionItems = new Array<OptionView>();
    this.pUiService.chosenOption = new OptionView();
    this.pUiService.chosenOption.ProductOptionItem = new ProductOption();
    this.pUiService.chosenOption.AvailableFileFormatItems =
      new Array<AvailableFileFormat>();
    const availableFileFormat = new AvailableFileFormat();
    this.pUiService.chosenOption.AvailableFileFormatItems.push(
      availableFileFormat
    );
    this.pUiService.chosenOption.DayAndPricesItems = new Array<DaysPrice>();
    const existFileFormat = new ExistFileFormat();
    this.pUiService.chosenOption.FixesPricesItems = new Array<FixesPrices>();
    this.pUiService.chosenOption.ExistFileFormatItems =
      new Array<ExistFileFormat>();
    this.pUiService.chosenOption.ExistFileFormatItems.push(existFileFormat);
  }

  GetDefaultChosenOption(): OptionView {
    let i = 0;
    let chosenOption = null;
    for (const item of this.pUiService.productView.ProductOptionItems) {
      if (item.ProductOptionItem.IsDefault) {
        this.pUiService.currentOptionIndex = i;
        chosenOption = item;
      }
      i++;
    }
    if (chosenOption == null) {
      chosenOption = this.pUiService.productView.ProductOptionItems[0];
    }
    return chosenOption;
  }

  backToStageOne(): void {
    this.pUiService.backToStageOne();
  }

  private _handleGetProductError(error): void {
    this.gaAnalyticsService.logEventToGa(
      "updateProductData",
      "OnlineProductDetailsComponent",
      EVENT_TYPES.Error
    );
    this.loaderService.hideLoader();
    console.log(error);
  }
  
  ngOnDestroy(): void {
    this._componentActive = false;
    if (
      document.querySelector(".body-online") &&
      document.querySelector(".body-online").classList
    ) {
      document.querySelector(".body-online").classList.remove("details-page");
    }
  }
}
